export interface IClientStrategy {
  clientStrategyId: number,
  strategyGoals: string,
  deliveryStatus: DeliveryStatus,
  cosaProjects: string,
  params: IStrategyParams[]
}

export interface IStrategyParams {
  strategyName: string,
  requiredActions: string,
  startDate: Date,
  endDate: Date
}

export enum DeliveryStatus {
  DELIVERY = 'DELIVERY',
  PICKUP = 'PICKUP',
  DELIVERY_PICKUP = 'DELIVERY_PICKUP'
}



// WEBPACK FOOTER //
// ./src/modules/clients/model/client.model.ts